import React, {useState,useEffect} from 'react';
import { useTheme } from "@mui/material/styles";
import { useNavigate } from 'react-router-dom';
import { Typography, IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Dialog, DialogTitle, DialogContent, DialogActions, Button, Divider, Box, TableRow, TableCell, LinearProgress } from '@mui/material';
import { Edit, Visibility, Block, CheckCircle, Share, PersonAdd, MoreVert, ContentCopy, Delete,Favorite,FavoriteBorder,AddCircleOutline,RemoveCircleOutline } from '@mui/icons-material';
import { useUser } from '../../context/UserContext';
import { useToast } from '../../context/ToastContext';
import { courseService, learningPathService,jobAidService,certificateService } from '../../services/api';
import moment from 'moment';
import '../Course/CourseGrid.css';
import { tokens } from '../../theme';
import TypeTag from '../shared/TypeTag';

const ItemListView = ({ item, onItemAction, itemType, context="" , className = "", isAdded }) => {

  const navigate = useNavigate();
  const { user } = useUser();
  const { showToast } = useToast();
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const [confirmDialog, setConfirmDialog] = useState({ open: false, type: '', id: null });
  // Prefer bookmark included on item; otherwise use shared cache to avoid many requests
  const [bookmarked, setBookmarked] = useState(Boolean(item?.bookmarked || item?.isBookmarked));
  const open = Boolean(anchorEl);


  // Determine if we're dealing with a course or learning path
  // const isCourse = itemType === 'course';
  const isCourse = itemType === 'course';
  const isLearningPath = itemType === 'learningPath';
  const isCertificate = itemType === "certificate";
  // const isJobAid = itemType === 'job Aid';
  const isJobAid = itemType?.toLowerCase() === 'job aid';

  // Get the appropriate service
  // const service = isCourse ? courseService : learningPathService;
   const service = isCourse ? courseService : isLearningPath ? learningPathService : isCertificate ? certificateService : jobAidService;
  
  // Get the appropriate field names
  // const titleField = isCourse ? 'name' : 'title';
  // const imagePath = isCourse ? 'courses' : 'learning_path';
  const isLearner = user?.role_name?.toLowerCase() === 'learner' || user?.current_role_id === 2;
  const titleField = isCourse ? 'name' : 'title';
  const imagePath = isCourse ? 'courses' : isLearningPath ? 'learning_path' : isCertificate ? 'certificates' : 'job-aids';
  const itemTypeName = isCourse ? 'Course' : isLearningPath ? 'Learning Path' : isCertificate ? 'Certificate' : 'Job Aid';
  const isMyLearningCard = !!item.customButton && !item.isCatalogCard;
  const isCatalogCard = !!item.isCatalogCard;
  // Permission mapping
  const permissions = {
    create: isCourse ? 'create_course': isLearningPath ? 'create_learning_path': isCertificate ? 'create_certificate' : 'create_job_aids',
    edit: isCourse ? 'edit_course' : isLearningPath ? 'edit_learning_path' : isCertificate ? 'edit_certificate' : 'edit_job_aids',
    delete: isCourse ? 'delete_course' : isLearningPath ? 'delete_learning_path' :  isCertificate ? 'delete_certificate' : 'delete_job_aids',
    enroll: isCourse ? 'enroll_learners_course' : 'enroll_learner_lp',
    disable: isCourse ? 'disable_course' : isLearningPath ? 'disable_learning_path' :  isCertificate ? 'disable_certificate' : 'disable_job_aids',
    view: isCourse ? 'view_course': isLearningPath ? 'view_learning_path' :  isCertificate ? 'view_certificate' : 'view_job_aids',
    //view: isCourse ? `/course/preview/${item.id}` : isLearningPath ? `/learning_path/preview/${item.id}` : isCertificate ? `/certificates/update/${item.id}` : `/job-aids/preview/${item.id}`,
  };
  
  // Check user permissions
  const canCreate = user.permissions?.includes(permissions.create);
  const canEdit = user.permissions?.includes(permissions.edit);
  const canDelete = user.permissions?.includes(permissions.delete);
  const canManageLearners = user.permissions?.includes(permissions.enroll);
  const canDisable = user.permissions?.includes(permissions.disable);
  const canView = user.permissions?.includes(permissions.view);

  // URL paths
  const paths = {
    // view: isCourse ? `/course/instances/${item.id}` : `/learning_path/instances/${item.id}`,
    // edit: isCourse ? `/course/form/${item.id}` : `/learning_path/form/${item.id}`,
    view: isCourse ? `/course/preview/${item.id}` : isLearningPath ? `/learning_path/preview/${item.id}` : isCertificate ? `/certificates/update/${item.id}` : `/job-aids/preview/${item.id}`,
    edit: isCourse ? `/course/form/${item.id}`: isLearningPath ? `/learning_path/form/${item.id}`: isCertificate ? `/certificates/update/${item.id}` : `/job-aids/edit/${item.id}`,
    enroll: isCourse ? `/course/learners/${item.id}` : `/learning_path/enroll/${item.id}`,
    preview: isCourse ? `/course/preview/${item.id}` : isLearningPath ? `/learning_path/view/${item.id}` : isCertificate ? `/certificates/update/${item.id}` : `/job-aids/preview/${item.id}`,
  };

  const handleMenuClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleCopyUrl = () => {
    const url = `${window.location.origin}${paths.preview}`;
    navigator.clipboard.writeText(url)
      .then(() => {
        showToast(`${isCourse ? 'Course' : 'Learning Path'} URL copied to clipboard!`, 'success');
      })
      .catch(err => {
        console.error('Failed to copy URL: ', err);
        showToast('Failed to copy URL', 'error');
      });
    handleMenuClose();
  };
  
  const handleEnroll = () => {
    navigate(paths.enroll);
    handleMenuClose();
  };

  const handleView = () => {
    navigate(paths.view);
    handleMenuClose();
  };

  const handleEdit = () => {
    navigate(paths.edit);
    handleMenuClose();
  };

  const openConfirmDialog = (type, id) => {
    setConfirmDialog({ open: true, type, id });
    handleMenuClose();
  };

  const closeConfirmDialog = () => {
    setConfirmDialog({ open: false, type: '', id: null });
  };

const handlePreviewCourse = (course) => {
  const instanceId = course.default_instance_id || 0;
  navigate(`/course/preview/${item.id}`);
};
const getStatusLabel = (status) => {
  if (isJobAid) {
    return status === 1 ? 'Published' : '';
  }
  if (status === "3" || status === 3) return 'Published';
  if (status === "2" || status === 2) return 'Retired';
  return 'Draft';
}; 
 const getStatusClass = (status) => {
  if ((isJobAid && status === 1) || status === 3 || status === '3') return 'status-published-text';
  return 'status-draft-text';
};
  const getStatusColor = (status) => {
    if (itemType === "job Aid") {
      return status === 1 ? tokens.color.status.activeText : tokens.color.textTertiary;
    }
    if (status === "3" || status === 3) return tokens.color.status.activeText;  // Published (active green)
    if (status === "2" || status === 2) return tokens.color.textTertiary;  // Retired (muted)
    return tokens.color.textSecondary; // Draft (neutral)
  };
  
  const StatusDot = ({ status }) => {
    const label = getStatusLabel(status);
    if (!label) return null;
    const color = getStatusColor(status);
    return (
      <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
        <Box component="span" sx={{ width: "7px", height: "7px", borderRadius: "50%", background: color, flexShrink: 0 }} />
        <Typography component="span" sx={{ fontSize: "12px", fontWeight: 500, color, lineHeight: 1 }}>
          {label}
        </Typography>
      </Box>
    );
  };

   

useEffect(() => {
  let isMounted = true;

  if (typeof item?.bookmarked !== 'undefined' || typeof item?.isBookmarked !== 'undefined') {
    setBookmarked(Boolean(item?.bookmarked || item?.isBookmarked));
  }

  // Do not perform client-side bookmark fetches; rely on server to include `bookmarked`.
  return () => { isMounted = false };
}, [itemType, item.id, item?.bookmarked, item?.isBookmarked]);

const toggleBookmark = async (event) => {
  event.stopPropagation(); 

  try {
    if (bookmarked) {
      await courseService.removeBookmark(item.id);
      setBookmarked(false);
      showToast("Bookmark removed successfully", "success");
    } else {
      await courseService.addBookmark(item.id);
      setBookmarked(true);
      showToast("Bookmark added successfully", "success");
    }
  } catch (error) {
    showToast(
      error.response?.data?.message || "Something went wrong",
    );
  }
};

  const handleConfirmAction = async () => {
    try {
      if (confirmDialog.type === 'publish') {
        await (isCourse ? service.publishCourse(confirmDialog.id) : isLearningPath ? service.publishLearningPath(confirmDialog.id) : isCertificate ? service.publishCertificate(confirmDialog.id) : service.publishJobAid(confirmDialog.id) );
        showToast(`${isCourse ? 'Course' : isLearningPath ? 'Learning Path' : isCertificate ? 'Certificate' : 'Job Aid' } published successfully`, 'success');
      } else if (confirmDialog.type === 'retire') {
        await (isCourse ? service.retireCourse(confirmDialog.id) : isCertificate ? service.retireCertificate(confirmDialog.id) : service.retireLearningPath(confirmDialog.id));
        showToast(`${isCourse ? 'Course' : isCertificate ? 'Certificate' :'Learning Path'} retired successfully`, 'success');
      } else if (confirmDialog.type === 'delete') {
        await (isCourse ? service.deleteCourse(confirmDialog.id) : isLearningPath ? service.deleteLearningPath(confirmDialog.id) : isCertificate ? service.deleteCertificate(confirmDialog.id) : service.deleteJobAid(confirmDialog.id));
        showToast(`${isCourse ? 'Course' : isLearningPath ? 'Learning Path' : isCertificate ? 'Certificate' : 'Job Aid'} deleted successfully`,'success');
      }else if (confirmDialog.type === 'duplicate') {
        await (isCourse ? service.duplicateCourse(confirmDialog.id) : isCertificate ? service.duplicateCertificate(confirmDialog.id) : service.duplicateLearningPath(confirmDialog.id));
        showToast(`${isCourse ? 'Course' : isCertificate ? 'Certificate'  :'Learning Path'} duplicated successfully`, 'success');
      }
      else if (confirmDialog.type === "add_course") {
      if (isCourse && context === "certificate") {
        onItemAction?.("add_course", item);   
        showToast("Course added to certificate successfully", "success");
      }
    } 
    else if (confirmDialog.type === "remove_course") {
      if (isCourse && context === "certificate") {
        onItemAction?.("remove_course", item); 
        showToast("Course removed from certificate successfully", "success");
      }
    }
      
      setTimeout(() => {
        onItemAction?.(); 
      }, 0);
    } catch (error) {
      console.error(`Error ${confirmDialog.type} ${isCourse ? 'course' : isLearningPath ? 'learning path' : isCertificate ? 'certificate' : 'job aid' }:`, error);
      showToast(`Failed to ${confirmDialog.type} ${isCourse ? 'course' : isLearningPath ? 'learning path' : isCertificate ? 'certificate' : 'job aid'}`, 'error');
    } finally {
      closeConfirmDialog();
    }
  };

  // Format the description by removing HTML tags
  const stripHtml = (html) => {
    if (!html) return '';
    const tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  };

  const truncateDescription = (description, maxLength = 150) => {
    if (!description) return '';
    const strippedDesc = stripHtml(description);
    return strippedDesc.length > maxLength 
      ? strippedDesc.substring(0, maxLength) + '...' 
      : strippedDesc;
  };

  const learnerView = isLearner && (
    <TableRow
      hover
      className="course-list-item learner-list-item"
      //onClick={() => navigate(paths.preview)}
      sx={{ cursor: 'pointer', display: 'inline-table' }}
    >
      
      <TableCell sx={{ verticalAlign: 'top', width: '20%' }}>
        <Typography variant="subtitle1" fontWeight={600} className="course-list-title">
          {item[titleField] || '—'}
        </Typography>
      </TableCell>
      <TableCell sx={{ verticalAlign: 'top', width: '15%' }}>
        <TypeTag type={itemTypeName} />
      </TableCell>
      <TableCell sx={{ verticalAlign: 'top', width: '5%' }}>  
        {itemType === 'course' && (
          <IconButton
            onClick={(e) => toggleBookmark(e)}
            className="fav-icon"
            disableRipple
            disableFocusRipple
            size="small"
            aria-label={bookmarked ? 'Remove bookmark' : 'Add bookmark'}
          >
            {bookmarked ? (
              <Favorite sx={{ fontSize: 18, color: tokens.color.status.alertText }} />
            ) : (
              <Favorite sx={{ fontSize: 18, color: 'rgba(0,0,0,0.3)', '&:hover': { color: tokens.color.status.alertText } }} />
            )}
          </IconButton>
        )}
      </TableCell>
      <TableCell sx={{ verticalAlign: 'top', width: '20%' }}>
        {typeof item.progress === 'number' ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <LinearProgress
              variant="determinate"
              value={Math.min(100, Math.round(item.progress) || 0)}
              sx={{ 
                flex: 1, 
                height: 8, 
                borderRadius: 3,
                backgroundColor: tokens.color.bgTertiary,
                '& .MuiLinearProgress-bar': {
                  backgroundColor: Math.min(100, Math.round(item.progress) || 0) >= 100 ? tokens.color.positive : tokens.color.brand,
                }, 
              }}
            />
            <Typography variant="caption" sx={{ fontWeight: 500, flexShrink: 0 }}>
              {Math.round(item.progress)}%
            </Typography>
          </Box>
        ) : '—'}
        {item.last_accessed_at && (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
            Last opened {moment(item.last_accessed_at).fromNow()}
          </Typography>
        )}
      </TableCell>

      <TableCell sx={{ verticalAlign: 'top', width: '30%' }}>
        <Typography variant="body2" color="text.secondary" className="course-list-description">
          {item.description ? truncateDescription(item.description) : (
            <Box component="span" sx={{ color: 'text.disabled' }}>No description</Box>
          )}
        </Typography>
      </TableCell>

      <TableCell align="right" sx={{ verticalAlign: 'top', width: '10%' }}>
        {item.customButton && !isJobAid && !isCertificate && (
          <Button
            variant="contained"
            size="small"
            color="primary"
            onClick={(e) => { e.stopPropagation(); item.customButton.onClick(e); }}
          >
            {item.customButton.text}
          </Button>
        )}
        {isJobAid && item.jobAids_url && (
          <Button
            variant="contained"
            size="small"
            color="primary"
            component="a"
            href={`/uploads/job-aids/${item.jobAids_url}`}
            target="_blank"
            rel="noopener noreferrer"
            download
            onClick={(e) => e.stopPropagation()}
          >
            Download
          </Button>
        )}
      </TableCell>
    </TableRow>
  );

  const adminView = (
    <>
      
        {/* Thumbnail removed — text-forward list row. */}
        <TableRow hover className="course-list-item" sx={{display: 'inline-table'}}>
          <TableCell sx={{ verticalAlign: 'top', width: '30%' }}>
            <Typography variant="subtitle1" fontWeight={600} className="course-list-title">
              {item[titleField] || '—'}
            </Typography>
          </TableCell>
          <TableCell sx={{ verticalAlign: 'top', width: '15%' }}>
            <TypeTag type={itemTypeName} />
          </TableCell>
          <TableCell sx={{ verticalAlign: 'top', width: '10%' }}>
            <div className="course-list-meta-row">
              <span className={`course-list-status ${getStatusClass(item.status)}`}>
                {getStatusLabel(item.status) || '—'}
              </span>
            </div>  
          </TableCell>    
          <TableCell sx={{ verticalAlign: 'top', width: '10%' }}>
            <div className="course-list-meta-row">    
              <span className="course-list-date">
                {item.created_at ? moment(item.created_at).format('MMM DD, YYYY') : '—'}
              </span>
            </div>
          </TableCell>
          <TableCell sx={{ verticalAlign: 'top', width: '30%' }}>
            <Typography variant="body2" color="text.secondary" className="course-list-description">
              {item.description ? truncateDescription(item.description) : (
                <Box component="span" sx={{ color: 'text.disabled' }}>No description</Box>
              )}
            </Typography>
          </TableCell>
          <TableCell align="right" sx={{ verticalAlign: 'top', width: '5%' }}>
            <IconButton
                aria-label="more"
                aria-controls="item-menu"
                aria-haspopup="true"
                onClick={handleMenuClick}
                size="small"
            >
                <MoreVert />
            </IconButton>
          </TableCell>
        </TableRow>
        <Menu
          id="item-menu"
          anchorEl={anchorEl}
          keepMounted
          open={open}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          slotProps={{
            paper: {
              sx: {
                // text color
                '& .MuiListItemText-primary': {
                  color: tokens.color.textPrimary,
                },
                // icon color
                '& .MuiListItemIcon-root': {
                  color: 'primary.main',
                  minWidth: 'auto !important',
                },
              },
            },
          }}
        >

        {context === 'certificate' && itemType === 'course' ? (
            <>
              {isAdded  ? (
              <MenuItem onClick={(e) => openConfirmDialog('remove_course',item.id, e)}>
                <ListItemIcon>
                  <RemoveCircleOutline fontSize="small" />
                </ListItemIcon>
                <ListItemText>Remove Course</ListItemText>
              </MenuItem>
            ) : (
              <MenuItem onClick={(e) => openConfirmDialog('add_course',item.id, e)}>
                <ListItemIcon>
                  <AddCircleOutline fontSize="small" />
                </ListItemIcon>
                <ListItemText>Add Course</ListItemText>
              </MenuItem>
              )}
        
              <MenuItem onClick={() => handlePreviewCourse(item.id)}>
                <ListItemIcon>
                  <Visibility fontSize="small" />
                </ListItemIcon>
                <ListItemText>Preview Course</ListItemText>
              </MenuItem>
            </>
          ) :(
            <>
          {/* {canView && (
              <MenuItem onClick={() => 
                canEdit && (item.status !== 3 && item.status !== '3') 
                  ? handleEdit() 
                  : handleView()
              }>
                <ListItemIcon><Visibility fontSize="small" /></ListItemIcon>
                <ListItemText>View {isCourse ? 'Course' : 'Learning Path'}</ListItemText>
              </MenuItem>
          )}
          {canEdit && (item.status !== 3 && item.status !== '3') && (
              <MenuItem onClick={handleEdit}>
                <ListItemIcon><Edit fontSize="small" /></ListItemIcon>
                <ListItemText>Edit {isCourse ? 'Course' : 'Learning Path'}</ListItemText>
              </MenuItem>
          )} */}
          {canView && (
          <MenuItem onClick={() =>
            canEdit && (item.status !== 3 && item.status !== '3' && item.status !== 1)
              ? handleEdit()
              : handleView()
          }>
            <ListItemIcon><Visibility fontSize="small" /></ListItemIcon>
            <ListItemText>View {itemTypeName}</ListItemText>
          </MenuItem>
          )}
          {canEdit && (item.status !== 3 && item.status !== '3' && item.status !== 1) && (
            <MenuItem onClick={handleEdit}>
              <ListItemIcon><Edit fontSize="small" /></ListItemIcon>
              <ListItemText>Edit {itemTypeName}</ListItemText>
            </MenuItem>
          )}

          {canView && isJobAid && item.status === 1 && (
            <MenuItem
              onClick={() => {
                navigate(paths.preview);
                handleMenuClose();
              }}
            >
              <ListItemIcon>
                <Visibility fontSize="small" />
              </ListItemIcon>
              <ListItemText>Preview {itemTypeName}</ListItemText>
            </MenuItem>
          )}


          {canManageLearners && (
          <MenuItem onClick={handleEnroll}>
              <ListItemIcon><PersonAdd fontSize="small" /></ListItemIcon>
              <ListItemText>Enroll Learners</ListItemText>
          </MenuItem>
          )}
          {/* {canDisable && (
              <>
                {item.status === 3 || item.status === '3' ? (
                  <MenuItem onClick={() => openConfirmDialog('retire', item.id)}>
                    <ListItemIcon><Block fontSize="small" /></ListItemIcon>
                    <ListItemText>Retire {isCourse ? 'Course' : 'Learning Path'}</ListItemText>
                  </MenuItem>
                ) : (
                  <MenuItem onClick={() => openConfirmDialog('publish', item.id)}>
                    <ListItemIcon><CheckCircle fontSize="small" /></ListItemIcon>
                    <ListItemText>Publish {isCourse ? 'Course' : 'Learning Path'}</ListItemText>
                  </MenuItem>
                )}
                
              </>
          )} */}
          {canDisable && (
                    <>
                      {/* Course or LP: Retire if Published (status 3) */}
                      {!isJobAid &&
                        (item.status === 3 || item.status === "3") && (
                          <MenuItem
                            onClick={(e) => openConfirmDialog("retire", item.id, e)}
                          >
                            <ListItemIcon>
                              <Block fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>Retire {itemTypeName}</ListItemText>
                          </MenuItem>
                        )}        
                      
          
                      {!isJobAid &&
                        item.status !== 3 &&
                        item.status !== "3" && (
                          <MenuItem
                            onClick={(e) => openConfirmDialog("publish", item.id, e)}
                          >
                            <ListItemIcon>
                              <CheckCircle fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>Publish {itemTypeName}</ListItemText>
                          </MenuItem>
                        )}
                    </>
                  )}
          {canCreate && (item.status === 3 || item.status === '3') && (
              <MenuItem onClick={() => openConfirmDialog('duplicate', item.id)}>
                <ListItemIcon><ContentCopy fontSize="small" /></ListItemIcon>
                <ListItemText>Duplicate {isCourse ? 'Course' : isCertificate ? 'Certificate' : 'Learning Path'}</ListItemText>
              </MenuItem>
          )}          
          {(item.status === 3 || item.status === '3') && (
          <MenuItem onClick={handleCopyUrl}>
              <ListItemIcon><Share fontSize="small" /></ListItemIcon>
              <ListItemText>Copy URL</ListItemText>
          </MenuItem>
          )}          
          {/* {canDelete && (item.status !== 3 && item.status !== '3')&& (
          <MenuItem onClick={() => openConfirmDialog('delete', item.id)}>
              <ListItemIcon><Delete fontSize="small" /></ListItemIcon>
              <ListItemText>Delete {isCourse ? 'Course' : 'Learning Path'}</ListItemText>
          </MenuItem>
          )} */}
          {canDelete && ((isJobAid && item.status !== 1) || (isJobAid && item.status !== 3 && item.status !== '3')) && (
          <MenuItem onClick={() => openConfirmDialog('delete', item.id)}>
            <ListItemIcon><Delete fontSize="small" /></ListItemIcon>
            <ListItemText>Delete {itemTypeName}</ListItemText>
          </MenuItem>
        )}
          </>
        )}
        </Menu>
      
    <Divider className="course-list-divider" />     

    <Dialog
      open={confirmDialog.open}
      onClose={closeConfirmDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {confirmDialog.type === 'publish' && `Publish ${isCourse ? 'Course' : isLearningPath ? 'Learning Path' : isCertificate ? 'Certificate' :'Job Aid'}`}
        {confirmDialog.type === 'retire' && `Retire ${isCourse ? 'Course' : isCertificate ? 'Certificate' : 'Learning Path'}`}
        {confirmDialog.type === 'delete' && `Delete ${isCourse ? 'Course' : isLearningPath ? 'Learning Path' : isCertificate ? 'Certificate' : 'Job Aid'}`}
        {confirmDialog.type === 'duplicate' && `Duplicate ${isCourse ? 'Course' : isCertificate ? 'Certificate' : 'Learning Path'}`}
         
         {confirmDialog.type === 'add_course' && `Add_Course ${isCourse ? 'Course' : 'Certificate'}`}
         {confirmDialog.type === 'remove_course' && `Remove_Course ${isCourse ? 'Course' : 'Certificate'}`}
      </DialogTitle>
      <DialogContent>
        <Typography>
          {confirmDialog.type === 'publish' && `Are you sure you want to publish this ${isCourse ? 'course' : isLearningPath ? 'learning path' : isCertificate ? 'Certificate' : 'Job Aid'}? It will be visible to all users.`}
          {confirmDialog.type === 'retire' && `Are you sure you want to retire this ${isCourse ? 'course' : 'learning path'}? It will no longer be available for enrollment.`}
          {confirmDialog.type === 'delete' && `Are you sure you want to delete this ${isCourse ? 'course' :  isLearningPath ? 'learning path' : isCertificate ? 'Certificate' : 'Job Aid'}? This action cannot be undone.`}
          {confirmDialog.type === 'duplicate' && `Are you sure you want to duplicate this ${isCourse ? 'course' : isCertificate ? 'Certificate' : 'learning path'}? A copy will be created with '(Copy)' added to the title.`}
          
          {confirmDialog.type === 'add_course' && `Are you sure you want to add this Course? It will no longer be available to learners.`}
          {confirmDialog.type === 'remove_course' && `Are you sure you want to remove this Course? This action cannot be undone.`}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeConfirmDialog} color="primary">
          Cancel
        </Button>
        <Button onClick={handleConfirmAction} color="primary" autoFocus>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
    </>
  );
  return  isLearner ? learnerView : adminView;
};

export default ItemListView;